import { withSentryReactRouterV6Routing } from '@sentry/react';
import { Routes } from 'react-router-dom';

export const SentryRoutes = withSentryReactRouterV6Routing(Routes);
